module.exports = __webpack_public_path__ + "static/media/fall.491b846.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/fall.mp3
// module id = JILm
// module chunks = 5